module.exports = __webpack_public_path__ + "static/media/signal-1.4672163f.svg";